export const sports = [
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Aquatics - Diving',
        code: 'DIV',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/23/2f8549bb-aec1-4be4-9ffc-e643572507ba/B2022-Aquatics-Diving.jpg?width=456&height=456',
        color: '#00B6F8',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Aquatics - Swimming and Para Swimming',
        code: 'SWM',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/23/14a160a6-537b-48bf-beef-88f7f9563d7e/B2022-Para-Swimming.jpg?width=456&height=456',
        color: '#00B6F8',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Athletics and Para Athletics',
        code: 'ATH',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/23/22fe81cd-9888-4bc5-a764-ef8aa82d3555/B2022-Para-Athletics.jpg?width=456&height=456',
        color: '#EA27C2',
    },
    {
        // added but missing from /sports tab
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Athletics - Marathon',
        code: 'ATH0201',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/23/22fe81cd-9888-4bc5-a764-ef8aa82d3555/B2022-Para-Athletics.jpg?width=456&height=456',
        color: '#EA27C2',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Badminton',
        code: 'BDM',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/08/0c2e2d27-11a7-4bd8-9a7a-2d380fe95f67/B2022-Badminton-Listing-03.jpg?width=456&height=456',
        color: '#FF9D1A',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Basketball 3x3', // Basketball 3x3 and Wheelchair Basketball 3x3
        code: 'BK3',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/11/3788514c-4479-4477-a683-4507adf147c6/Basketball-Listings-04-1.jpg?width=456&height=456',
        color: '#FF9D1A',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Beach Volleyball',
        code: 'VBV',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/08/be818fe1-6636-4d04-9e7e-aa775e1981a9/beach-volleyball-at-smithfield.jpg?width=456&height=456',
        color: '#00B6F8',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Boxing',
        code: 'BOX',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/22/d53fd6b3-5c56-43b8-8a9c-93da31bcf9cf/boxing_hero.jpeg?width=456&height=456',
        color: '#FF9D1A',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Cricket T20',
        code: 'CKT',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/10/f60a497c-38a9-4633-b1d0-c850fd60e97e/B2022-Cricket-Hero-01.jpg?width=456&height=456',
        color: '#CEDF00',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Cycling - Mountain Bike',
        code: 'MTB',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/22/0e91866e-432c-4499-9745-108efe162d96/B2022-Cycling-Hero-04.jpg?width=456&height=456',
        color: '#FF9D1A',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Cycling - Road Race',
        code: 'CRD1002',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/22/fb1c8deb-5d34-446d-86df-97e3a3c0d244/B2022-Cycling-Listing-02.jpg?width=456&height=456',
        color: '#EA27C2',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Cycling - Time Trial',
        code: 'CRD0701',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/22/b656250f-5da7-48c3-809a-e34c062fffa1/B2022-Cycling-Listing-03.jpg?width=456&height=456',
        color: '#CEDF00',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Cycling - Track and Para Track',
        code: 'CTR',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/25/a1825ec2-3c2c-4f3d-be20-c39fe46ac0c0/Track-Cycling.jpg?width=456&height=456',
        color: '#CEDF00',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Gymnastics - Artistic',
        code: 'GAR',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/22/da40a61d-e59f-410d-be55-920018ba6d55/B2022-Gymnastics-Listing-05.jpg?width=456&height=456',
        color: '#724DD6',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Gymnastics - Rythmic',
        code: 'GRY',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/22/d499b2b4-d328-4451-908b-874736aceec5/B2022-Gymnastics-Listing-03.jpg?width=456&height=456',
        color: '#724DD6',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Hockey',
        code: 'HOC',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/22/8fb12549-6f4f-49db-be52-3f26ff7d65de/B2022-Hockey-Listing-01.jpg?width=456&height=456',
        color: '#CEDF00',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Judo',
        code: 'JUD',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/22/ad0df12f-4409-4f2a-b6e7-a472057a0040/B2022-Judo-Hero-04.jpg?width=456&height=456',
        color: '#724DD6',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Lawn Bowls and Para Lawn Bowls',
        code: 'LBO',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/25/5438cafc-0943-4d0f-b531-dbe5000a183f/Lawn-Bowls-and-Para-Lawn-Bowls.jpg?width=456&height=456',
        color: '#CEDF00',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Netball',
        code: 'NBL',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/23/3523b66e-de41-46b8-b87a-837471807594/B2022-Netball-Listings-10.jpg?width=456&height=456',
        color: '#724DD6',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Para Powerlifting',
        code: 'PWL',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/25/ac8a403a-1cf7-4f72-b8cc-f136cf6aef3e/Para-Powerlifting.jpg?width=456&height=456',
        color: '#FF9D1A',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Rugby Sevens',
        code: 'RUG',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/25/ee922a84-c783-407d-8978-70a2fadf95dd/Rugby-Sevens-Try.jpg?width=456&height=456',
        color: '#CEDF00',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Squash',
        code: 'SQU',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/25/6039aa4f-ed60-4028-aa9d-6afb84064b61/Squash-Team-England.jpg?width=456&height=456',
        color: '#EA27C2',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Table Tennis and Para Table Tennis',
        code: 'TTE',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/25/9bdf215f-dffe-455d-a429-ceb32eb97b2b/Table-Tennis.jpg?width=456&height=456',
        color: '#FF9D1A',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Triathlon and Para Triathlon',
        code: 'TRI',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/25/4aa9761f-80a1-427d-b98e-0a0b56885be5/Alistair-and-Jonny-Brownlee-Triathlon.jpg?width=456&height=456',
        color: '#00B6F8',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Wheelchair Basketball 3x3',
        code: '',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/25/55811c17-55a8-4401-9104-bc36fb5ed82f/Siobhan-Fitzpatrick-Team-GB-Wheelchair-Basketball.jpg?width=456&height=456',
        color: '#FF9D1A',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Weightlifting',
        code: 'WLF',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/11/9a78647d-aaf1-455a-b814-2eb4780ec569/B2022-Weightlifting-Listings-02.jpg?width=456&height=456',
        color: '#FF9D1A',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Wrestling',
        code: 'WRE',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/11/58fc0b5a-f5ad-46cb-b91c-db7150b5f777/Wrestling.jpg?width=456&height=456',
        color: '#EA27C2',
    },
    {
        uuid: 'b6d1f147-8013-4eca-8bbc-5f0a185c6057',
        title: 'Opening and Closing Ceremonies',
        code: 'CER',
        logo: 'https://resources.cwg-qbr.pulselive.com/photo-resources/2022/02/11/58fc0b5a-f5ad-46cb-b91c-db7150b5f777/Wrestling.jpg?width=456&height=456',
        color: '#FFFFFF',
    },
]

export const normalizeSportCode = (sportCode: string) => {
    const aliases: Record<string, string> = {
        // Legacy code from older payloads.
        BB: 'BK3',
    }

    return aliases[sportCode] || sportCode
}

export const getColorFromSport = (sportCode: string) => {
    const normalizedSportCode = normalizeSportCode(sportCode)
    const sport = sports.find((el) => el.code === normalizedSportCode)
    if (sport) {
        return sport.color
    } else {
        return '#ffffff'
    }
}
